import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ResponseMessageType } from "~/domains";

type RequestDataType = {
  knowledgeInsightPostCommentId: string;
};

type MessageWithIdType = ResponseMessageType & {
  id: string;
};

const request = ({ knowledgeInsightPostCommentId }: RequestDataType) => {
  return new ApiClient()
    .post<MessageWithIdType>(
      `/api/members/knowledge_insight_post_comments/${knowledgeInsightPostCommentId}/likes`,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisMembersKnowledgeInsightPostCommentsLikesCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<MessageWithIdType, RequestDataType> => {
  return useMutation(request, { ...options });
};
